import React from 'react'
import LgyLink from 'app/components/util/lgy-link/LgyLink'

const FourOhFourFallback = () =>
  <div style={{ textAlign: "center" }}>
    <h1>404 / Page not found</h1>
    <p>You might want to double-check your link and try again, or return to the <LgyLink to='/lgyhub'>LGY homepage</LgyLink>.</p>
  </div>

export default FourOhFourFallback
